/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import React, { ReactNode, ReactElement } from 'react';
import { createGlobalStyle } from 'styled-components';

import ThemeManager from '@userzoomlibraries/toolkit-theme-manager';

import base from '@userzoomlibraries/toolkit-themes-userzoom-platform-base';
import icons from '@userzoomlibraries/toolkit-themes-userzoom-platform-icons';
import UzGlobalStyles from '@userzoomlibraries/toolkit-themes-userzoom-platform-globals';

import globalStyles from '../../styles/global';
import ThemeComponents from '../../styles/theme-components';

const GlobalStyles = createGlobalStyle`${globalStyles}`;

type Props = {
	children: ReactNode;
};

const NewUi = ({ children }: Props): ReactElement => (
	<ThemeManager base={base} icons={icons} styles={ThemeComponents}>
		<UzGlobalStyles />
		<GlobalStyles />
		{children}
	</ThemeManager>
);

export default NewUi;
